<template>
  <form method="GET" :action="action">
    <div class="panel panel-default">
      <div class="panel-body">

        <div v-if="fields.length === 0" class="alert alert-warning text-center mb-0">
          {{ noFieldsText }}
        </div>

        <template v-else>

          <div class="row">
            <div v-for="group in splitArrayToGroups(fields, 3)" class="col-md-4">
              <template v-for="field in group">
                <component :is="'filter-field-' + field.widget" v-bind="field.props" :value="state[field.id].value" :operator-value="state[field.id].operator_value"></component>
              </template>
            </div>
          </div>

          <hr class="hr-line-dashed"/>

          <div class="row mb-0">
            <div class="col-md-12">
              <div class="text-right">
                <button type="submit" name="filter" value="apply" class="btn btn-primary" :disabled="processingSubmit">Filter</button>
                <button type="submit" name="filter" value="clear" class="btn btn-default ml-1" :disabled="processingSubmit">Clear</button>
              </div>
            </div>
          </div>

        </template>

      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    action: {type: String, required: true},
    fields: {type: Array, default: function () { return [] }},
    state: {type: Object, default: function () { return {} }},
    noFieldsText: {type: String, default: 'There are currently no fields configured for the filter.'},
  },

  /**
   * Variables (models).
   */
  data () {
    return {
      processingSubmit: false,
    }
  },

  /**
   * Computed values
   */
  computed: {
  },

  /**
   * Functions (methods).
   */
  methods: {
  },
}
</script>
